import React from "react";
import { ShieldAlert } from "lucide-react";
import useTranslation from "hooks/useTranslation";
import "./style.scss";

export const BlockedAccountBanner = ({ onClick }) => {
	const { tr } = useTranslation();

	return (
		<div
			className="blocked-account-banner"
			onClick={onClick}
			role="button"
			tabIndex={0}
			onKeyDown={e => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					onClick?.();
				}
			}}
		>
			<div className="blocked-account-banner__main">
				<div className="blocked-account-banner__icon-wrap">
					<div className="blocked-account-banner__icon">
						<ShieldAlert size={28} strokeWidth={2} />
					</div>
				</div>

				<div className="blocked-account-banner__text">
					<h3 className="blocked-account-banner__title">
						{tr("Ваш аккаунт заблокирован.")}
					</h3>
					<p className="blocked-account-banner__desc">
						{tr(
							"Чтобы повторно активировать ваш аккаунт, пожалуйста, оплатите непогашенный остаток."
						)}
					</p>
				</div>
			</div>

			<button
				type="button"
				className="blocked-account-banner__cta"
				onClick={e => {
					e.stopPropagation();
					onClick?.();
				}}
			>
				{tr("Пополнить баланс")}
			</button>
		</div>
	);
};

export default BlockedAccountBanner;
